import React, { useRef }  from 'react';
import styled from 'styled-components';
import { Dictionery } from '../../Data/Dictionery';
import { Link } from 'react-router-dom';
import { IconChevron } from '../../Assets/IconChevron';
const Styles = styled.div`
    position: relative;
    .top {
        display: flex;
        margin: 0 0 1rem;
        justify-content: space-between;
        text-decoration: none;
        color: inherit;
        .title {
            font-size: 1.25rem;
            font-weight: 600;
        }
        .action {
            text-decoration: none;
            font-weight: 700;
            color: #0094FF;
        }
    }
    .scroll-container {
        overflow-x: auto;
        &::-webkit-scrollbar-track {
            display: none;
        }
        &::-webkit-scrollbar {
            display: none;
        }
        &::-webkit-scrollbar-thumb {
            display: none;
        }
    }
    .scrolable {
        display: flex;
        gap: 1rem;
        padding-bottom: 2.5rem;
    }
    .end-pad {
        color: transparent;
        font-size: 0.1rem;
        width: 0;
    }
    .arrow {
        z-index: 50;
        isolation: isolate;
        position: absolute;
        top: calc(calc(100% - 46px) / 2);
        padding: 1rem 0.5rem;
        border-radius: 100px;
        background: linear-gradient(180deg, #E5E5E5 0%, #7F7F7F00 100%);
        cursor: pointer;
        &::before {
            content: "";
            z-index: -1;
            position: absolute;
            inset: 1px;
            border-radius: 100px;
            background: #FFFFFFea;
        }
        svg {
            display: block;
        }
        &.left {
            left: -36px;
        }
        &.right {
            right: -36px;
        }
    }
    @media screen and (max-width: 850px) {
        .top {
            margin: 0 var(--universal-pad) 1rem;
        }
        .end-pad {
            color: transparent;
            font-size: 0.1rem;
            width: 0;
        }
        .scroll-container {
            padding: 0 var(--universal-pad);
        }
        .arrow {
            display: none;
        }
    }
`
export default function CarouselMain (props){
    const ref = useRef()
    const {title, moreLink, lan, children} = props;
    const goScroll = (dir) => {
        let size = ref.current.offsetWidth / 2;
        ref.current.scrollTo({
            left: ref.current.scrollLeft + (dir*size),
            behavior: 'smooth',
        })
    }
    return (
        <Styles>
            {
                (moreLink) ? (
                    <Link to={"/" + lan.filename + moreLink} className='top'>
                        <h2 className='title'>
                            {title}
                        </h2>
                        <div className='action'>
                            {Dictionery.more[lan.filename]}
                        </div>
                    </Link>
                ) : (
                    <div className='top'>
                        <h2 className='title'>
                            {title}
                        </h2>
                    </div>
                )
            }
            <div className='scroll-container' ref={ref}>
                <div className='scrolable' >
                    {children}
                    <div className='end-pad'>-</div>
                </div>
            </div>
            <div className='arrow left' onClick={() => goScroll(-1)}>
                <IconChevron style={{rotate: "180deg"}}/>
            </div>
            <div className='arrow right' onClick={() => goScroll(1)}>
                <IconChevron/>
            </div>
        </Styles>
    )
}

